export default {
  campaigns: [],
  contacts: [],
  pagination: {},
  paginationC: {},
  campaign: {}
}
